import * as Yup from 'yup';
import i18n from 'i18n';

export const getCertificateSchema = ({
  mode,
  isEditingPassword,
}: {
  mode: 'create' | 'edit';
  isEditingPassword: boolean;
}) =>
  Yup.object().shape({
    name: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    path: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    password:
      mode === 'create' || isEditingPassword
        ? Yup.string().required(i18n.t('REQUIRED_FIELD_KEY'))
        : Yup.string().notRequired(),
  });
